import { ThankYouContainer } from '@screens/review-section2/thank-you/styles';
import {
    CompletionIcon,
    CompletionText
} from '@screens/review-section3/review/styles';
import { IConfigurationValuesService } from '@services/ConfigurationValuesService';
import { createTranslationService, createConfigurationValuesService } from '@services/factories';
import { ISection2ThankyouStore } from '@stores/onboarding-review/section2-thankyou-store';
import { cacheTranslations } from '@utils/cache-translations';
import { observer } from 'mobx-react';
import { Box, Link, Container } from '@material-ui/core';
import * as React from 'react';

interface IProps {
    store: ISection2ThankyouStore;
}

enum Translation {
    invitationMessage = 'invitationMessage',
    invitationCTAText = 'invitationCTAText',
    willBeInTouchWithWorkerTemplate = 'willBeInTouchWithWorkerTemplate',
    applicationResubmittedToApplicant = 'applicationResubmittedToApplicant',
    title = 'title'
}

class ThankYouPage extends React.Component<IProps> {
    readonly translations = cacheTranslations(
        createTranslationService(),
        Translation,
        'section2ThankYou'
    );

    readonly configurationValuesService: IConfigurationValuesService = createConfigurationValuesService();

    render() {
        return (
            <Box p={3} width={'100%'}>
                <ThankYouContainer>
                    <div>
                        <CompletionIcon fontSize={'large'}/>
                    </div>
                    <CompletionText>{this.translations.title}</CompletionText>
                    {this.configurationValuesService.displayInvitationLink ? <Container maxWidth={'sm'}>
                        <Box p={2}>
                            {this.translations.invitationMessage} <Link href={this.configurationValuesService.invitationURL}>{this.translations.invitationCTAText}</Link>
                        </Box>
                    </Container> : null}
                    {/*{*/}
                    {/*    this.props.store.shouldShowFlowFinished && (*/}
                    {/*        <authenticationParamsContext.Consumer>*/}
                    {/*            {*/}
                    {/*                params => <CompoundTranslation template={this.translations.willBeInTouchWithWorkerTemplate}*/}
                    {/*                                               as={FlowFeedbackMessage}*/}
                    {/*                                               data={[params?.candidateFirstName ?? '']} />*/}
                    {/*            }*/}
                    {/*        </authenticationParamsContext.Consumer>*/}
                    {/*    )*/}
                    {/*}*/}
                    {/*{*/}
                    {/*    this.props.store.shouldShowFlowReset && (*/}
                    {/*        <FlowFeedbackMessage>{this.translations.applicationResubmittedToApplicant}</FlowFeedbackMessage>*/}
                    {/*    )*/}
                    {/*}*/}
                </ThankYouContainer>
            </Box>
        );
    }
}

export default observer(ThankYouPage);



// WEBPACK FOOTER //
// ./src/screens/review-section2/thank-you/thank-you-page.tsx